import { render, staticRenderFns } from "./RecaptchaComponent.vue?vue&type=template&id=cad762ea"
import script from "./RecaptchaComponent.vue?vue&type=script&lang=js"
export * from "./RecaptchaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports